import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Globals } from "src/app/common/global";
import { ConfigApi } from "src/app/config-api";
import { ApiCallingService } from "src/app/services/api-calling.service";

@Component({
  selector: "app-product-lists",
  templateUrl: "./product-lists.component.html",
  styleUrls: ["./product-lists.component.css"],
})
export class ProductListsComponent implements OnInit {
  categoryData: any[] = [];
  page: number = 1;
  pageSize: number = 10;
  totalCount: number = 0;
  loading: boolean = false;
  userDetails: any;
  categoryId: any;
  selectedProduct: any = null;

  constructor(
    private apiCallingService: ApiCallingService,
    private toastr: ToastrService,
    public globals: Globals,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute
  ) {
    this.categoryId = this.route.snapshot.paramMap.get("id");

    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.getProductList();
  }

  getProductList() {
    this.loading = true;
    this.apiCallingService
      .callAPI(
        {
          category_id: this.categoryId,
          operator_id: this.userDetails._id,
          page: this.page - 1,
          limit: this.pageSize,
        },
        "POST",
        ConfigApi.URLS.VENDING_CATEGORY.VENDING_CATEGORY_PRODUCT_LIST
      )
      .subscribe(
        (res) => {
          if (this.apiCallingService.handleSuccess(res)) {
            this.categoryData = res.data || [];
            this.totalCount = res.total || 0;
          }
          this.loading = false;
        },
        (error) => {
          console.error(error);
          this.toastr.error("Failed to load categories");
          this.loading = false;
        }
      );
  }

  openUnlinkModal(content: any, product: any) {
    this.selectedProduct = product;
    this.modalService.open(content, {
      centered: true,
      backdrop: "static",
    });
  }

  confirmUnlink(modal: any) {
    if (!this.selectedProduct) return;

    const url = `${ConfigApi.URLS.VENDING_CATEGORY.UNLINK_PRODUCT_FROM_CATEGORY}/${this.selectedProduct._id}`;

    const payload = {
      category_id: this.categoryId,
    };

    this.apiCallingService.callAPI(payload, "POST", url).subscribe(
      (res) => {
        if (this.apiCallingService.handleSuccess(res)) {
          this.toastr.success("Product removed from category");
          modal.close();

          this.categoryData = this.categoryData.filter(
            (p) => p._id !== this.selectedProduct._id
          );
        }
      },
      (error) => {
        console.error(error);
        this.toastr.error("Failed to remove product");
      }
    );
  }
}
